export enum AuthMethod {
    USER,
    EMAIL,
    RFID
}